
<div class="my-5 bg-white" style="font-family: Montserrat;">
<div class="flex gap-3 my-4 items-center mx-4">
    <img (click)="backClicked()" class="rounded-full w-6 h-6 bg-blue-500 cursor-pointer mt-3" src="assets/back-icon.svg">
    <p class="font-semibold text-xl mt-3">Authentication</p>
    <h4 class="text-gray-500 mt-3">|</h4>
    <div class="slideToggle  px-2 py-1 bg-blue-100 rounded-lg relative cursor-pointer flex items-center justify-center gap-2 mt-3" [class.checked]="isChecked" (click)="toggle()"  style="border: 1px solid #386AF6;" >
        <span style="font-size: 12px;">{{ isChecked ? 'Active' : 'Inactive' }}</span>
        <div [style.backgroundColor]="isChecked ? '#386AF6' : '#CCCCCC'" style="width: 28px; height: 14px; border-radius: 14px;">
          <div class="auth-slider"></div>
    </div>
</div>
</div>

<div *ngIf="isChecked">
  <div class="mx-4 bg-white" [formGroup]="authDetailsForm">
    <div
    class="flex flex-col gap-3 rounded-2xl border border-gray-300"
      style="
        padding: 16px 20px;
      "
    >
    <div class="font-semibold mx-3" style="font-size: 16px;">Authentication URL</div>
    <div class="flex justify-center gap-3 mx-3" style=" width: fit-content;">
        <input formControlName="authUrl" class="lable-input"
          style="
            border: 0px;
            border-bottom: 1px solid #ECECEC;
            width: 500px;
            font-size: 12px;
            font-weight: 400;
            box-shadow: none;
          "
          placeholder="https://www.redhat.com/en/topics/automation"
        />
        <br />
        <!-- <button
          style="
            color: #386AF6;
            border: 1px solid #386AF6;
            padding: 8px 30px;
            border-radius: 50px;
            background-color: white;
            font-size: 14px;
          "
        >
          Verify
        </button> -->
    </div>
    <div [formGroup]="authDetailsForm" class="font-semibold mt-3 mx-3" style="font-size: 16px; ">Enter the Input Fields</div>
        <ng-container *ngFor="let field of inputLoopArray">
            <div class="flex w-50 gap-4">
                <select [formControlName]="'inputFieldType'+field"  class="lable-input p-2 rounded-lg mx-3 px-4" style="font-size: 12px; border: 1px solid #ECECEC;" name="inputFields" >
                    <option value="TEXT">Input text field</option>
                    <option value="NUMBER">Number data field</option>
                    <option value="DATE">Date field</option>
                </select>
                <div class="flex items-center gap-5">
                    <div class="flex flex-col gap-2">
                        <label style="font-size:12px; color:gray;">Enter label name</label>
                        <input [formControlName]="'inputFieldName'+field" class="lable-input" style="font-size:12px; font-weight:400; border: 0px; border-bottom: 1px solid #ECECEC;" type="text" name="labelName" placeholder="" >
                    </div>
                    <div class="flex flex-col gap-2">
                      <label style="font-size:12px; color:gray">Enter label key</label>
                      <input  [formControlName]="'inputFieldValue'+field" class="lable-input" style="font-size:12px; font-weight:400; border: 0px; border-bottom: 1px solid #ECECEC;"  type="text" name="labelName" placeholder="">
                  </div>
                    <img *ngIf="inputFields > 1" src="assets/delete-icon.svg" style="cursor: pointer;" (click)="deleteInputField(field)">
                </div>
            </div>
        </ng-container>
        <div style= "margin-top: 20px; font-size: 16px;">
          <a *ngIf="inputFields < 4" (click)="addNextInputField()" class="text-left cursor-pointer text-blue-500 mx-3">+ Add Input field</a>
        </div>
        <div style="margin-top: 20px; margin-bottom: 16px;">
          <button (click)="updateAuthentication()"
          [style.background-color]="authDetailsForm.valid ? '#386AF6' : '#E0E7FF'"
          [disabled]="!authDetailsForm.valid"
          class="mx-3  text-white font-medium"
          style="
            padding: 5px 50px;
            width: fit-content;
            border-radius: 80px;
            font-size: 14px;
          "
        >
          Confirm
        </button>
        </div>
    </div>
  </div>
</div>
<div *ngIf="!isChecked">
  <div style="align-items: center; justify-content: center; display: flex; flex-direction: column;">
    <img src="../../assets/mesage-main.svg">
    <br>
    <span style="font-family: Montserrat; font-size: 12px; letter-spacing: 2%; margin-bottom: 50px;">Authentication is currently inactive</span>
  </div>
</div>

